import { useContext } from 'react';
import QuestionnaireContext, { QuestionnaireContextType } from './QuestionnaireContext';

const useQuestionnaireContext = (): QuestionnaireContextType => {
  const context = useContext(QuestionnaireContext);
  if (!context) {
    throw new Error('useQuestionnaireContext must be used within a QuestionnaireProvider');
  }
  return context;
};

export default useQuestionnaireContext;